import { Module } from "vuex";
import AuthService from "@/services/auth.service";
import { ConfirmOtpPayload, SendOtpParams } from "@/struct/AuthStruct";
import {
  getTokenFromCookies,
  removeTokenFromCookies,
  setTokenToCookies,
} from "@/utils/common";
import router from "@/router";
import type { RootState } from "@/store";

export interface AuthState {
  isLoading: boolean;
  isAuth: boolean;
}

const authService = new AuthService();

const authModule: Module<AuthState, RootState> = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    isAuth: false,
  }),
  getters: {},
  mutations: {
    SET_LOADING(state, value: boolean) {
      state.isLoading = value;
    },
    SET_AUTH(state, isAuth: boolean) {
      state.isAuth = isAuth;
    },
  },
  actions: {
    setAuth({ commit }, isAuth: boolean) {
      commit("SET_AUTH", isAuth);
    },
    requestOtp({ dispatch }, params: SendOtpParams) {
      return authService.sendOtp(params).catch(() => {
        dispatch(
          "system/openModal",
          { presetKey: "general_error" },
          { root: true }
        );
      });
    },
    verifyOtp({ dispatch }, payload: ConfirmOtpPayload) {
      return authService
        .confirmOtp(payload)
        .then((data) => {
          if (data.data.status) {
            setTokenToCookies(data.data.response);
            dispatch("setAuth", false);
            dispatch("analytics/incrementVisitCount", null, { root: true });
          }
          return {
            status: data.data.status,
          };
        })
        .catch(() => {
          dispatch(
            "system/openModal",
            {
              presetKey: "general_error",
            },
            { root: true }
          );
        });
    },
    logout({ dispatch }) {
      if (!getTokenFromCookies()) return;
      return authService
        .logout()
        .catch(() => {
          console.error("Error Logout Back");
          console.warn("Сервер отказал в logout");
          //всё равно разлогиним локально, не пробрасываем ошибку
        })
        .then(() => {
          removeTokenFromCookies();
          dispatch("clearLocalDataStore", null, { root: true });
          dispatch("setAuth", false);
        })
        .finally(() => {
          router.push("/");
        });
    },
  },
  modules: {},
};

export default authModule;
